/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import {
  ITableHeaders,
  IStatementDetails,
} from '../../../types/CounterpartyStatements';

interface IMultiSheet {
  name: string;
  mappings: Array<ITableHeaders>;
  data: Array<IStatementDetails>;
}

export interface ICounterpartyStatementsDetails {
  multiSheets: IMultiSheet[];
}

export const initialState: ICounterpartyStatementsDetails = {
  multiSheets: [],
};
const CounterpartyStatementsDetails = createSlice({
  name: 'counterpartyStatementsDetails',
  initialState,
  reducers: {
    setMultiSheets: (state, action) => {
      state.multiSheets = action.payload;
    },
    resetMultiSheets: (state) => {
      state.multiSheets = [];
    },
  },
});

export const counterpartyStatementsDetailsActions =
  CounterpartyStatementsDetails.actions;
export default CounterpartyStatementsDetails.reducer;
